export default "__VITE_ASSET__CyUQWaSn__"